import React, { useState, useEffect, useContext } from "react";
import mercado from "../../img/mercado-pago.png";
import Product from "../Product";
import firebase from 'firebase/app';
import Selects from '../Selects';
import "./css.css";
import 'firebase/database';
import ProductsContext from '../Context/AppContext';
import {useUser} from 'reactfire';

export default function List() {
  const [loading, setLoading] = useState(false);

  const {products, setProducts, cantProdView, setCantProdView, category, setCategory, scrollTop, setScrollTop, sizes, setSizes} = useContext(ProductsContext);

  const handleMoreProd = () => {
    setCantProdView(cantProdView + 3);
    updateProducts(category, cantProdView + 3);
    setScrollTop(window.pageYOffset);
  }

  const handleChangeCategory = (e) => {
    const cat = e.target.value;
    setCategory(cat);
    setCantProdView(6);
    setSizes('');
    setScrollTop(window.pageYOffset);
    updateProducts(cat, 6);
  };

  const handleChangeSizes = (e) => {
    const value = e.target.value;
    setSizes(value);
  };

  const updateProducts = async (cat, cantProd) => {
    if(cantProd === 6) 
      setLoading(true)
    const db = firebase.database().ref('/products');
    var objProducts = {};
    if(cat !== '')
      objProducts = await db.orderByChild("category").equalTo(cat).once('value');
    else
      objProducts = await db.limitToLast(cantProd).once('value');
    let newData = [];
    for(const product in objProducts.val())
      newData.push(objProducts.val()[product]);
      if(category !== '') newData.sort(() => {return Math.random() - 0.5});
      else  newData.reverse();
    setProducts(newData);
    setLoading(false);
}


  useEffect(() => {
    const getProducts = async () => {
      setLoading(true)
      const db = firebase.database().ref('/products');
      var objProducts = {};
      if(category !== '')
        objProducts = await db.orderByChild("category").equalTo(category).once('value');
      else
        objProducts = await db.limitToLast(6).once('value');
      let newData = [];
      for(const product in objProducts.val())
        newData.push(objProducts.val()[product]);
      if(category !== '') newData.sort(() => {return Math.random() - 0.5});
      else  newData.reverse();
      setProducts(newData);
      setLoading(false);
    }
    if(products === null)
      getProducts();
    else
      window.scroll(0, scrollTop);
    

  }, [setProducts, products, scrollTop, category])


  const filter = (product) => {
    let filterSize = false;
    if (sizes === "") filterSize = true;
    else for (const s of product.sizes) if (s === sizes) filterSize = true;
    return filterSize;
  }

  const handleActualize = () => {updateProducts(category, cantProdView)}

  return (
    <div className="content-list">
      <div className="send">
        <span role="img" aria-label="minibus">🚐</span>
        <p> Envío GRATIS a domicilio (Dolores)</p>
      </div>
      <div className="send">
        <span role="img" aria-label="dollar banknote">💵</span>
        <p>Pagos en efectivo con 10% de descuento</p>
      </div>
      <div className="send">
        <span role="img" aria-label="credit card">💳</span>
        <p>Compras con todas las tarjetas</p>
      </div>
      <img className="mercado" src={mercado} alt="Envío" />
      <div className="filters">
        <Selects handleChangeCategory={handleChangeCategory} category={category} handleChangeSizes={handleChangeSizes} sizes={sizes} />
      </div>
      {useUser() && <div className="content-button"><button onClick={handleActualize} className="button">Actualizar</button></div>}
      <div className="content-button"><p className="press-image">Presione la imágen para ver mas información</p></div>
      {loading ? <div className="cargando"></div>
      :<div className="list">
        {products && products.map((product, index) => (
          (category === '' || filter(product)) &&
              <Product
                key={index}
                img={product.img}
                sizes={product.sizes}
                price={product.price}
                id={product._id}
                category={product.category}
                name={product.name}
              />
            ))}
      </div>
    }

      {products && products.length === cantProdView &&
        <div className="content-button"><button className="button more" onClick={handleMoreProd}>Cargar mas productos</button></div>
      }
    </div>
  );
}
